export var actions = {
    doClearFilters() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                Object.keys(this.filterState.filters)
                    .forEach(filterKey => {
                        this.filterState.filters[filterKey].forEach(filter => {
                            filter.selected = false
                        })
                    })

                this.filterState.search = null

                resolve()
            }, 100)
        })
    },

    clearFiltersAndLoadPage() {
        return this.doClearFilters().then(() => {
            this.doLoadPage()
        })
    },

    doSetPageIsReady(bool = true) {
        return new Promise((resolve, reject) => {
            this.pageIsReady = bool
            resolve()
        })
    },

    showFilter(filter) {
        this.filterState.showFilterMenu = true
        this.filterState.showFilter = filter
    },

    hideFilterMenu() {
        this.filterState.showFilterMenu = false
        this.filterState.showFilter = null
    },


    loadFiltersRequest() {
        this.filterState.loading = true
        this.data = []
    },

    loadFiltersRequestSuccess(data) {
        this.filterState.filters = data
        this.filterState.loading = false
    },

    loadFiltersRequestFailure() {
        this.filterState.loading = false
    },

    loadPageRequest(displayLoad) {
        this.pagination.current_page = 1
        if (displayLoad) {
            this.loading = true
        }
        this.noResultsMessage = 'Loading...'
    },

    /*
       loadPageRequestSuccess mutation must be defined for each equipment store using this
     */
    loadPageRequestFailure() {
        this.loading = false
    },

    loadMoreRequest() {
        this.loadingMore = true
        this.pagination.current_page++
    },

    loadMoreRequestSuccess(data) {
        this.pagination.total = data.resultsTotal

        this.data = [
            ...this.data,
            ...Object.values(data.data)
        ]

        this.loadingMore = false
    },

    loadMoreRequestFailure() {
        this.loadingMore = false
    }
}

export var getters = {
    checkedFilters: state => {
        let checkedFilters = {}
        Object.keys(state.filterState.filters)
            .forEach(filterKey => {
                checkedFilters[filterKey] = []
                Object.keys(state.filterState.filters[filterKey])
                    .forEach(filterValueKey => {
                        let filterValue = state.filterState.filters[filterKey][filterValueKey];
                        if (filterValue.selected) {
                            if (Object.keys(filterValue).includes('id')) {
                                checkedFilters[filterKey].push(filterValue.id)
                            } else {
                                checkedFilters[filterKey].push(filterValue.title)
                            }
                        }
                    })
            })
        return checkedFilters
    }
}
